export default function handleResponse(response: any): Promise<any> {
  return response.text().then((text: string) => {
    if (response.status >= 400) {
      return Promise.reject({text, status: response.status});

    }
    const data = text && JSON.parse(text);
    if (!response.ok) {
      return Promise.reject({...data, status: response.status});
    }

    return data;
  });
}
